"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.FormatMessage = void 0;
var FormatMessage_1 = require("./FormatMessage");
Object.defineProperty(exports, "FormatMessage", { enumerable: true, get: function () { return FormatMessage_1.FormatMessage; } });
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return FormatMessage_1.FormatMessage; } });
//# sourceMappingURL=index.js.map